import { Injectable, NgZone } from '@angular/core'
import { Subject } from 'rxjs'
import { SyncPhaseDto } from 'src/app/services/dtos'

@Injectable({ providedIn: 'root' })
export class CrossTabSyncService {
  // Other contexts' mutations land here. BroadcastChannel does NOT deliver to the
  // sender, so the acting tab never re-triggers itself — no echo loop.
  readonly applicationChanged$ = new Subject<{
    accountId: string
    applicationId: string
    optimisticPhase: SyncPhaseDto | null
  }>()
  private channel = new BroadcastChannel('arpio-app-sync')

  // onmessage runs outside Angular's zone (not Zone-patched, same class as
  // CLAUDE.md pitfall #7) — zone.run so change detection fires.
  constructor(private zone: NgZone) {
    this.channel.onmessage = (e) => this.zone.run(() => this.applicationChanged$.next(e.data))
  }

  notifyApplicationChanged(accountId: string, applicationId: string, optimisticPhase: SyncPhaseDto | null): void {
    this.channel.postMessage({ accountId, applicationId, optimisticPhase })
  }
}
